import { render, staticRenderFns } from "./BankStatements.vue?vue&type=template&id=433d4d22&scoped=true"
import script from "./BankStatements.vue?vue&type=script&lang=js"
export * from "./BankStatements.vue?vue&type=script&lang=js"
import style0 from "./BankStatements.vue?vue&type=style&index=0&id=433d4d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433d4d22",
  null
  
)

export default component.exports